import bootstrap from 'bootstrap';
import Utility from "./utility";

class Tabs {

    tabContainers: NodeListOf<HTMLElement>;
    stickyTabs: NodeListOf<HTMLElement>;
    defaultTabs: NodeListOf<HTMLElement>;
    defaultTabsActive: NodeListOf<HTMLElement>;
    utility = Utility;

    constructor() {
        this.init();
    }

    init() {
        this.tabContainers = document.querySelectorAll('.tabs-container');
        this.stickyTabs = document.querySelectorAll('.tabs-container.banner-tabs');
        this.defaultTabs = document.querySelectorAll('.tabs-container.default-tabs');
        this.defaultTabsActive = document.querySelectorAll('.default-tabs button.active');
        
    }

    start() {
        const urlHash = window.location.hash;

        // Add arrow to active tabs (only for default tabs)
        this.defaultTabsActive.forEach(function(activeTab){
            const tabArrowHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="30" viewBox="0 0 43 30"><path d="M19.062,3.4a3,3,0,0,1,4.877,0L39.6,25.252A3,3,0,0,1,37.159,30H5.841A3,3,0,0,1,3.4,25.252Z" transform="translate(43 30) rotate(180)" fill="#005eb8"/></svg>';
            const tabArrow = document.createElement("div");
            tabArrow.className = "active-tab-arrow";
            tabArrow.innerHTML = tabArrowHTML;
            activeTab.appendChild(tabArrow);
        });

        // Add current tab name to mobile bar for sticky tabs ("banner-tabs")
        this.stickyTabs.forEach(function(stickyTab){
            let activeTab = stickyTab.querySelector("ul.nav button.active").innerHTML;
            let activeTabTitle = stickyTab.querySelector(".tab-group-title h4");
            if(activeTabTitle != null){
                activeTabTitle.innerHTML = activeTab;
            }
        });
        
        // Fire events on Bootstrap show event
        document.addEventListener('shown.bs.tab', function(e: Event)
        {
            let target: HTMLElement = e.target as HTMLElement;
            let targetParent: HTMLElement = target.closest(".tabs-container");
            
            // Add active tab ID to url when shown
            // remove scroll class
            // window.location.hash = target.id;
            
            // Move arrow to active tab on default tabs
            if ( !target.hasAttribute("data-shown") && targetParent.classList.contains("default-tabs"))
            {
                let tabArrow = target.closest('ul.nav').querySelector('.active-tab-arrow');
                target.appendChild(tabArrow);
            }

            // Add current tab name to mobile bar for sticky tabs ("banner-tabs")
            if (targetParent.classList.contains("banner-tabs"))
            {
                let targetTitle = target.innerHTML;
                let activeTabTitle = targetParent.querySelector('.tab-group-title h4');
                let parentNav = target.closest('.navbar-collapse');
                
                if(activeTabTitle != null){
                    activeTabTitle.innerHTML = targetTitle;
                }
                if(parentNav != null){
                    if(window.innerWidth <= 768){
                        let bsCollapse = new bootstrap.Collapse(parentNav, {
                            toggle: true
                        })
                        bsCollapse.hide();
                    }
                }
                
            }

        });

        this.tabContainers.forEach(function(container) {
            let eNav: HTMLElement = container.querySelector('.nav-placeholder-container');
            let parentSection: HTMLElement;

            if (container.dataset.sticky && eNav != null)
            {
                parentSection = eNav.closest('section');
                //need to add overflow visible to parent section for position:sticky to work
                parentSection.style.overflow = "visible";  
                document.addEventListener('scroll', function(e)
                {
                    let viewPortTop: number = eNav.getBoundingClientRect().top;

                    if (viewPortTop < 46.88 && !eNav.classList.contains('is-fixed'))
                    {
                        //console.log('add')
                        // get elements that need to be hidden or shown based on if nav is fixed
                        // this is not in the main scroll area to save memory on scrolling
                        let fixedShownElements: NodeListOf<HTMLElement> = container.querySelectorAll('[data-shown="fixed"]');
                        fixedShownElements.forEach(function(element) {
                            element.style.display = 'block';
                        });
                        eNav.dataset.offset = (eNav.getBoundingClientRect().top + scrollY - 30).toString();
                        eNav.classList.add('is-fixed');
                        container.querySelectorAll('button').forEach(function(item){
                            item.classList.add('no-outline');
                        });
                    } else if (eNav.classList.contains('is-fixed') && (scrollY < parseFloat(eNav.dataset.offset))) {
                        let fixedShownElements: NodeListOf<HTMLElement> = container.querySelectorAll('[data-shown="fixed"]');
                        fixedShownElements.forEach(function(element) {
                            element.style.display = 'none';
                        });
                        eNav.classList.remove('is-fixed');
                        container.querySelectorAll('button').forEach(function(item){
                            item.classList.remove('no-outline');
                        });
                    }
                });
            }
        });

        // TODO: Testing Tab on  load
        if (window.location.hash)
        {
            loadTabActive();
        }

        function loadTabActive(){
            const urlHash = window.location.hash.substring(1);
            if(urlHash){
                let tabExists = false;
                let thisTab;
                //is there a better way to do this lol
                const generalTab: HTMLElement = document.querySelector('#tab-' + urlHash);
                const activeIntakeTab: HTMLElement = document.querySelector('button#'+urlHash);
                
                if(generalTab != null){
                    thisTab = generalTab;
                    tabExists = true;
                } else if(activeIntakeTab != null){
                    thisTab = activeIntakeTab;
                    tabExists = true;
                }
                if(tabExists){
                    const tabContainer = thisTab.offsetParent as HTMLElement;
                    thisTab.click();
                    window.scrollTo(0, tabContainer.offsetTop);
                }
            }
        }

        // Change view on load/resize

        let tabContainers = this.tabContainers;

        window.addEventListener('resize', function(){
            tabCollapse(tabContainers);
        });

        document.addEventListener('DOMContentLoaded', function(){
            tabCollapse(tabContainers);
        });

        function tabCollapse(containers: NodeListOf<HTMLElement>) {

            containers.forEach(function(container: HTMLElement) {

                let containerNav: HTMLElement = container.querySelector('ul.nav');
                let containerTabs = container.querySelectorAll('ul.nav li');

                if (container.classList.contains("default-tabs")) {

                    let containerNavWidth = containerNav.offsetWidth;
                    let containerTabsWidth = 0;
                    
                    containerTabs.forEach(function(tab: HTMLElement){
                        containerTabsWidth+=tab.offsetWidth;
                    });

                    if (containerTabsWidth > containerNavWidth) {
                        document.querySelector('.active-tab-arrow').classList.add('d-none');
                        if(this.utility.isTouchDevice()){
                            //Add scroll if on touch device
                            container.classList.add("mobile-tabs");
                        }
                    } else {
                        if (container.classList.contains("mobile-tabs")) 
                        {
                            container.classList.remove("mobile-tabs");
                            document.querySelector('.active-tab-arrow').classList.remove('d-none');
                        }
                    }

                }

            });
        }

        //
        let aHrefs = document.querySelectorAll('[href$="-bs-tab"]');
        if(aHrefs !== null){
            aHrefs.forEach((ele : HTMLAnchorElement)=>{
                if(ele !== null)
                {
                    ele.addEventListener("click", () =>{
                        let ahref = new URL(ele.href);
                        let tabElHash = document.querySelector('button[data-bs-target="'+ ahref.hash +'"]');
                        var tab = new bootstrap.Tab(tabElHash);
                        tab.show();
                    });
                }
            })
        }
        
    }

}

export default Tabs;